import { useQuery } from '@tanstack/react-query';

import { fetchOCSortingFields } from '../../data-provider/select-options';

export const useGetOCSortingFields = () => {
  return useQuery({
    queryFn: () => fetchOCSortingFields(),
    queryKey: ['claims-over-charge-sorting-fields'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
